export const hotjarEvent = (type: string, tag: string): void => {
    if (typeof window !== 'undefined') {
        // @ts-ignore
        if (window.hj) {
            // @ts-ignore
            window.hj(type, tag);
        }
    }
};
